import { BaseDataBind } from "./base";

export class ElementDataBind extends BaseDataBind
{
    public attributeName = 'data-bind-as';
    public selector = '[data-bind-as]';
    public eventNames = [];

    protected getPropertyValue(element: Element)
    {
        let name = super.getPropertyValue(element);
        
        this.view[name] = element;
        return name;
    }


    protected setElementValue(element: Element, value: any)
    {

    }

    protected getElementValue(element: Element): any
    {
        return undefined;
    }
}